import { EE } from '@/utils/aievent'
import { formatTime, replaceCitation } from '@/utils/outline'
import bluebird from 'bluebird'
import chalk from 'chalk'
import { cloneDeep } from 'lodash'
import { useEffect, useRef } from 'react'
import { history, useModel } from 'umi'
import { v4 as uuidV4 } from 'uuid'

/**
 * dev开发环境使用，都是Mock数据，用于调试
 * 在Mock数据的方式和和正式的数据会略有不同
 */
const useAiOutlineMock = () => {
  const {
    precondition,
    setInAIOutlineProcess,
    updateRequestStatusRef,
    outlineRefs,
    requestStatusRef,
    setRequestStatus,
    setOutlines,
    stopAIGenerate,
    stopAIRequestRef,
    handleAIWritingStatus,
  } = useModel('aiOutline')
  const { methods } = useModel('editor')
  const { updatePageInfo } = useModel('pageModel')
  const { handleInitStatus } = useModel('domCheck')
  const methodsRef = useRef(methods)

  const commonTime = 10

  useEffect(() => {
    methodsRef.current = methods
  }, [methods])

  // const articleRef = useRef('')
  let timer: any

  // 获取大纲
  const getOutlineListMock = async () => {
    let currentIndex = 0 // 大纲下标
    stopAIRequestRef.current = false
    updateRequestStatusRef({
      begin: true,
      outlineLoading: true,
      outlineLoaded: false,
      titleLoading: true,
    })
    console.log(chalk.bgYellowBright('开始AI生成大纲标题'))

    await sleep(1000)
    console.log('precondition', precondition)
    const beginTime = performance.now()

    return new Promise(async (resolve) => {
      updateRequestStatusRef({
        titleLoadingPosition: currentIndex,
      })

      const data = await mockData()
      timer = setInterval(() => {
        const res = data.next()
        const newOutline = outlineRefs.current
        if (res.done) {
          updateRequestStatusRef({
            titleLoading: false,
            titleLoaded: true,
          })
          clearInterval(timer)
          resolve('')
          console.log(chalk.blue('结束大纲标题生成'))

          return
        }

        // 调节大纲数量，方便调试
        if (currentIndex > 0) {
          clearInterval(timer)
          updateRequestStatusRef({
            titleLoading: false,
            titleLoaded: true,
          })
          resolve('')
          console.log(chalk.blue('结束大纲标题生成'))
          const endTime = performance.now()
          console.log(chalk.bgRedBright('大纲流式接口开启前耗时时间：'), formatTime(beginTime, endTime))

          return
        }

        if (!newOutline[currentIndex]) {
          newOutline[currentIndex] = {
            id: uuidV4(),
            title: '',
            concepts: [],
            text: '',
          }
        }

        // 根据分割符，要做一些列状态更新
        if (res.value === ';') {
          currentIndex++
          requestStatusRef.current.titleLoadingPosition = currentIndex
          setRequestStatus(cloneDeep(requestStatusRef.current))
          return
        }

        newOutline[currentIndex].title += res.value
        setOutlines(cloneDeep(newOutline))
      }, commonTime)
    })
  }

  // 获取大纲的写作问题（mock数据、批量获取）
  const getOutlineConceptByBatchMock = async () => {
    console.log('precondition', precondition)
    updateRequestStatusRef({
      conceptLoading: true,
      conceptLoaded: false,
    })
    await bluebird.mapSeries(outlineRefs.current, async (item, idx) => {
      // 获取单个大纲的写作问题
      await getConceptBySingleOutlineMock(idx)
    })

    updateRequestStatusRef({
      conceptLoaded: true,
      conceptLoading: false,
    })
  }

  // 获取单个大纲的写作问题
  const getConceptBySingleOutlineMock = async (outlineIndex: number) => {
    return new Promise(async (resolve) => {
      let conceptIndex = 0
      // 更新当前正在获取写文思路的大纲下标
      updateRequestStatusRef({
        conceptLoading: true,
        conceptLoadingPosition: outlineIndex,
      })

      const data = await mockData()
      timer = setInterval(() => {
        const res = data.next()

        if (res.done) {
          // console.log('当前写问结束', outlineIndex)
          clearInterval(timer)
          updateRequestStatusRef({
            conceptLoaded: true,
            conceptLoading: false,
          })
          resolve('')
        }

        if (outlineRefs.current.length === 0) {
          return
        }
        const { concepts } = outlineRefs.current[outlineIndex]
        // 根据分割符，要做一些列状态更新
        if (res.value === ';') {
          conceptIndex++
          return
        }
        if (!concepts[conceptIndex]) {
          concepts[conceptIndex] = {
            id: uuidV4(),
            question: '',
            answerLoaded: false,
          }
        }
        concepts[conceptIndex].question += res.value
        setOutlines(cloneDeep(outlineRefs.current))
      }, commonTime)
    })
  }

  // mock: 大纲取数（批量）
  const getAIConceptSourceDataByBatchMock = async () => {
    const newOutline = cloneDeep(outlineRefs.current)
    await bluebird.mapSeries(newOutline, async (item, idx) => {
      await getSourceDataBySingleOutlineMock(idx)
    })

    updateRequestStatusRef({
      referenceLoading: false,
      referenceLoaded: true,
    })
  }

  // mock:获取单个大纲的写作问题取数
  const getSourceDataBySingleOutlineMock = async (
    outlineIndex: number,
    option?: {
      openCheck: boolean
    },
  ) => {
    // 兼容退出AI生成的操作
    if (outlineRefs.current.length === 0) {
      return
    }
    const { concepts } = outlineRefs.current[outlineIndex]

    updateRequestStatusRef({
      referenceLoading: true,
      referenceLoaded: false,
      referenceLoadingPosition: outlineIndex,
    })

    await bluebird.mapSeries(concepts, async (ele, index) => {
      if (stopAIRequestRef.current) {
        return
      }
      const answer =
        '测试啊大量空间法律的激发健康啦大家案[citation:1]例肯德基案例的激发考虑的测试啊大量空间[citation:2]法律的激发健康啦大家案例肯德基案例的激发考虑的激发激发'
      const reference = ['xxx', '来源2']

      if (option && option.openCheck) {
        // 既不是新增的，文本也没有被修改过，直接跳过。
        if (!ele.isNew && !ele.textChanged) {
          return
        }
      }

      const newAnswer = answer.replace(/citation:\d+/g, (citation: string) => replaceCitation(citation, reference))
      // 如果中断AI生成，就跳过
      if (outlineRefs.current.length === 0) {
        return
      }
      // 先改一下状态
      outlineRefs.current[outlineIndex].concepts[index] = {
        ...outlineRefs.current[outlineIndex].concepts[index],
        answerLoaded: false,
        answerLoading: true,
      }
      setOutlines(cloneDeep(outlineRefs.current))

      // 模拟取数时间
      await sleep(500)
      // 如果中断AI生成，就跳过
      if (outlineRefs.current.length === 0) {
        return
      }
      // 再更新状态
      outlineRefs.current[outlineIndex].concepts[index] = {
        ...outlineRefs.current[outlineIndex].concepts[index],
        answer: newAnswer,
        reference: reference,
        answerStatus: Math.random() > 0.5, // 随机默认取书状态
        answerLoaded: true,
        answerLoading: false,
        isNew: false,
        textChanged: false,
      }

      setOutlines(cloneDeep(outlineRefs.current))
    })
  }

  // Mock:批量执行分析+段落获取： 当前大纲完成分析后,立马获取段落
  const getAIAnalysisAndParagraphByBatchMock = async () => {
    await bluebird.mapSeries(outlineRefs.current, async (item, idx) => {
      await getAnalysisBySingleOutlineMock(idx)
    })

    requestStatusRef.current = {
      ...requestStatusRef.current,
      textLoading: false,
      textLoaded: true,
      outlineLoaded: true,
      outlineLoading: false,
    }
    setRequestStatus(cloneDeep(requestStatusRef.current))
  }

  // 获取单个大纲的数据分析+段落获取
  const getAnalysisBySingleOutlineMock = async (
    outlineIndex: number,
    option?: {
      openCheck: boolean
    },
  ) => {
    console.log('分析。。。。。。。。。', outlineIndex)
    updateRequestStatusRef({
      analysisLoading: true,
      analysisLoaded: false,
      analysisLoadingPosition: outlineIndex,
      textLoading: false,
      textLoaded: true,
    })
    // 如果中断AI生成，就跳过
    if (outlineRefs.current.length === 0) {
      return
    }

    const currentOutline = outlineRefs.current[outlineIndex]
    await bluebird.mapSeries(currentOutline.concepts, async (ele, index) => {
      if (option && option.openCheck) {
        // 不需要重新分析
        if (!ele.needReanalysis) {
          return
        }
      }
      // 模拟数据分析时间
      await sleep(500)
      // 如果中断AI生成，就跳过
      if (outlineRefs.current.length === 0) {
        return
      }

      outlineRefs.current[outlineIndex].concepts[index] = {
        ...outlineRefs.current[outlineIndex].concepts[index],
        needReanalysis: false,
      }
      setOutlines(cloneDeep(outlineRefs.current))
    })

    // 执行完分析后,获取段落文本
    await getAIParagraphMock2(outlineIndex)
  }

  // 获取段落--Mock数据
  const getAIParagraphMock2 = async (outlineIndex: number) => {
    console.log('获取段落中,,,,,,', outlineIndex)
    // 更新当前正在获取写文思路的大纲下标
    updateRequestStatusRef({
      textLoading: true,
      textLoaded: false,
      textLoadingPosition: outlineIndex,
      analysisLoaded: true,
      analysisLoading: false,
    })

    // console.log('获取写问思路', outlineIndex)
    const data = await mockData2()

    return new Promise((resolve) => {
      timer = setInterval(() => {
        const res = data.next()
        if (res.done) {
          clearInterval(timer)
          console.log('获取文本结束')
          resolve('')
          return
        }

        // 如果中断AI生成，就跳过
        if (outlineRefs.current.length === 0) {
          return
        }
        const currentOutline = outlineRefs.current[outlineIndex]
        currentOutline.text += res.value
        setOutlines(cloneDeep(outlineRefs.current))
      }, commonTime)
    })
  }

  // 生成最后的文章
  const generateArticleMock = async () => {
    // const articleId = await createDraft()
    history.push(`/writer/${'11111'}`)
    setInAIOutlineProcess(false)
    const data = await mockArticle()
    await sleep(1000)
    EE.emit('updatePages') // 更新文章列表

    return new Promise((resolve) => {
      let firstLineBreak = true
      let title = ''
      let resultText = ''
      let cacheIndex = 0
      timer = setInterval(() => {
        const res = data.next()
        if (res.done) {
          console.log('插入完毕', resultText)
          handleAIWritingStatus(false)
          clearInterval(timer)
          // 写入完毕，触发保存
          EE.emit('savePage')
          // 初始化DOM监听
          handleInitStatus(true)

          resolve('')
          return
        }

        // if (title.length === 0 && res.value === 'Title') {

        // }

        if (res.value === '\n' && firstLineBreak) {
          firstLineBreak = false
          // 第一个换行符丢弃
          return
        }

        if (firstLineBreak) {
          if (cacheIndex > 1 && title.startsWith('Title:')) {
            title = ''
          }

          title += res.value
          cacheIndex++

          if (cacheIndex > 1) {
            updatePageInfo({
              id: '11111',
              title,
            })
          }
          return
        }

        resultText += res.value

        methodsRef.current?.insertNewNodes(resultText)
      }, commonTime)
    })
  }


  const sleep = (ms: any) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  const mockData = () => {
    const data = [
      'Understanding',
      'Customer',
      ' ',
      'Needs',
      ' ',
      'Creating',
      ' ',
      'Successful',
      ' ',
      'Marketing',
      ' ',
      'Plan',
      ' ',
      ';',
      'Customer',
      ' ',
      'Needs',
      ';',
      'Creating',
      ' ',
      'Successful',
      ' ',
      'Marketing',
      ' ',
      'Plan',
      ';',
      'Building',
      ' ',
      'Strong',
      ' ',
      'Brand',
    ]

    let currentIndex = 0
    return {
      next: () => {
        if (currentIndex >= data.length || stopAIRequestRef.current) {
          return {
            done: true,
            value: '',
          }
        }

        const word = data[currentIndex]
        currentIndex++

        return {
          done: false,
          value: word,
        }
      },
    }
  }

  const mockData2 = () => {
    const data = [
      'Hello',
      ' ',
      'world!',
      ' ',
      'I',
      ' ',
      'am',
      ' ',
      'learning',
      ' ',
      'JavaScript.',
      ' ',
      'Can',
      ' ',
      'you',
      ' ',
      'find',
      ' ',
      'the',
      ' ',
      'speed',
      ' ',
      'of',
      ' ',
      'light?',
      ' ',
      'Yes',
      ' ',
      'I',
      ' ',
      'can',
      'Hello',
      ' ',
      'world!',
      ' ',
      'I',
      ' ',
      'am',
      ' ',
      'learning',
    ]

    let currentIndex = 0
    return {
      next: () => {
        if (currentIndex >= data.length || stopAIRequestRef.current) {
          return {
            done: true,
            value: '',
          }
        }

        const word = data[currentIndex]
        currentIndex++

        return {
          done: false,
          value: word,
        }
      },
    }
  }

  const mockArticle = () => {
    const text = `Title: 这 是 标 题 测 试 测 试 测 试 测 试 测 试 \n The winter season in China's Hangzhou City is usually cold and short, but the beauty of West Lake is even more extraordinary in this season. As one of the most famous scenic spots in Hangzhou, West Lake is known for its picturesque scenery throughout the year, but its winter scenery is particularly stunning.\n
    The winter landscape of West Lake is characterized by its serenity and tranquility. The lake is covered with a layer of snow, which reflects the sky and the surrounding mountains. The trees around the lake are also covered with snow, creating a magical atmosphere. The whole scene is like a painting,和平静而美丽。\n
    One of the best things about the winter scenery of West Lake is the lack of crowds. During the winter, the lake is much quieter and less crowded than in the spring, summer, or autumn. This allows visitors to fully appreciate the beauty of the scenery and enjoy a more peaceful experience.\n
`

    const list = text.split(' ')
    const data: any = []
    list.forEach((ele) => {
      data.push(ele, ' ')
    })

    let currentIndex = 0

    return {
      next: () => {
        if (currentIndex >= data.length || stopAIRequestRef.current) {
          return {
            done: true,
            value: '',
          }
        }

        const word = data[currentIndex]
        currentIndex++

        return {
          done: false,
          value: word,
        }
      },
    }
  }

  // 编辑大纲标题后的重新生成
  const generateNewOutlineMock = async (outlineIndex: number) => {
    handleAIWritingStatus(true)
    updateRequestStatusRef({
      outlineLoading: true,
      outlineLoaded: false,
      conceptLoaded: false,
      conceptLoading: true,
      referenceLoading: false,
      referenceLoaded: false,
      referenceLoadingPosition: outlineIndex,
    })
    // 生成新的问题
    await getConceptBySingleOutlineMock(outlineIndex)
    updateRequestStatusRef({
      conceptLoaded: true,
      conceptLoading: false,
    })

    // 新的问题再取数
    await getSourceDataBySingleOutlineMock(outlineIndex)
    updateRequestStatusRef({
      referenceLoading: false,
      referenceLoaded: true,
    })
    // 分析数据+生成文本
    await getAnalysisBySingleOutlineMock(outlineIndex)
    console.log('立马结束')
    updateRequestStatusRef({
      outlineLoading: false,
      outlineLoaded: true,
      textLoaded: true,
      textLoading: false,
    })
  }

  // 编辑（或新增）某个大纲下面的写作问题后的重新生成
  const generateNewConceptReferenceMock = async (outlineIndex: number) => {
    handleAIWritingStatus(true)
    updateRequestStatusRef({
      outlineLoading: true,
      outlineLoaded: false,
    })

    const needRetrievedata = outlineRefs.current[outlineIndex].concepts.some((ele) => {
      return ele.textChanged
    })

    if (needRetrievedata) {
      // 被编辑的问题的取数
      await getSourceDataBySingleOutlineMock(outlineIndex, { openCheck: true })
      updateRequestStatusRef({
        referenceLoading: false,
        referenceLoaded: true,
        // referenceLoadingPosition: outlineIndex
      })
      // 取数完成后再把更改的（或者新增的问题）问题进行分析，然后再获取段落
      await getAnalysisBySingleOutlineMock(outlineIndex, { openCheck: true })
    } else {
      // 没有新的取数，就不用分析，可以直接重新获取段落
      await getAIParagraphMock2(outlineIndex)
    }

    updateRequestStatusRef({
      outlineLoading: false,
      outlineLoaded: true,
      textLoaded: true,
      textLoading: false,
      textLoadingPosition: -1,
    })
  }

  // 停止AI生成（mock数据）
  const stopAIGenerateMock = () => {
    clearInterval(timer)
    stopAIGenerate()
    handleAIWritingStatus(false)
  }

  // 初始化AI大纲的整体生成流程(Mock流程)
  const initAIGenerateProcessMock = async () => {
    handleAIWritingStatus(true)
    await getOutlineListMock()
    await getOutlineConceptByBatchMock()
    await getAIConceptSourceDataByBatchMock()
    await getAIAnalysisAndParagraphByBatchMock()
    updateRequestStatusRef({
      outlineLoading: false,
      outlineLoaded: true,
      textLoaded: true,
      textLoading: false,
    })
  }

  // Mock数据
  return {
    getOutlineListMock,
    getOutlineConceptByBatchMock,
    getAIConceptSourceDataByBatchMock,
    getAIAnalysisAndParagraphByBatchMock,
    generateNewOutlineMock,
    generateArticleMock,
    generateNewConceptReferenceMock,
    stopAIGenerateMock,
    initAIGenerateProcessMock,
  }
}

export default useAiOutlineMock
